module.exports = __webpack_public_path__ + "static/tote-1894ac6d5beb914f4d679f681746f71c.jpg";